export const INIT = 'app/OrganizersListPage/INIT';
export const INIT_SUCCESS = 'app/OrganizersListPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/OrganizersListPage/INIT_FAILED';

export const UPDATE = 'app/OrganizersListPage/UPDATE';
export const UPDATE_SUCCESS = 'app/OrganizersListPage/UPDATE_SUCCESS';
export const UPDATE_FAILED = 'app/OrganizersListPage/UPDATE_FAILED';

export const SET_FETCH_PARAMS = 'app/OrganizersListPage/SET_FETCH_PARAMS';
